<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Driver</h4>
  <button type="button" class="btn-close bg-secondary" aria-label="Close" (click)="dismiss()"></button>
</div>
@if (vm$ | async; as vm) {
  <div class="modal-body d-flex flex-column">
    <form
      id="3da94a1a-7a43-4ccd-bf88-498c6f861bfc"
      class="d-flex flex-fill flex-column"
      [formGroup]="form"
      (ngSubmit)="submit()">
      <div class="row align-items-start g-2 m-1">
        <div class="col-lg-6">
          <div class="row align-items-center g-1">
            <div class="col-12">
              <div class="small fw-semibold">Contact Info</div>
            </div>
            <div class="col-sm-6">
              <div class="form-floating">
                <input type="text" class="form-control validated" id="name" formControlName="firstName" />
                <label for="name">Name</label>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-floating">
                <input type="text" class="form-control validated" id="surname" formControlName="lastName" />
                <label for="surname">Surname</label>
              </div>
            </div>
            <div class="col-sm-6">
              <p-iftalabel>
                <p-datepicker
                  formControlName="birthDate"
                  inputId="birthDate"
                  showIcon
                  iconDisplay="input"
                  appendTo="body" />
                <label for="birthDate">Birth Date</label>
              </p-iftalabel>
            </div>
            <div class="col-sm-6">
              <div class="form-floating">
                <input type="text" class="form-control validated" id="birthPlace" formControlName="birthPlace" />
                <label for="birthPlace">Birth Place</label>
              </div>
            </div>
            <div class="col-12">
              <div class="form-floating">
                <input type="text" class="form-control validated" id="email" formControlName="email" />
                <label for="email">Email</label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-floating">
                <input type="text" class="form-control validated" id="phone" formControlName="phone" />
                <label for="phone">Phone</label>
              </div>
            </div>
            <div class="col-6">
              <div class="form-floating">
                <input type="text" class="form-control validated" id="mobile" formControlName="mobile" />
                <label for="mobile">Mobile</label>
              </div>
            </div>
            <div class="col-12">
              <div class="form-floating">
                <input type="text" class="form-control validated" id="address" formControlName="address" />
                <label for="address">Address</label>
              </div>
            </div>
            <div class="col-12">
              <p-iftalabel>
                <p-autocomplete
                  appCountryAutocomplete
                  [completeOnFocus]="true"
                  formControlName="countryUid"
                  optionLabel="label"
                  [forceSelection]="true"
                  [showClear]="true"
                  appendTo="body"
                  inputId="countryUid">
                  <ng-template let-country pTemplate="item">
                    <div>
                      <span class="flag-icon" [class]="country.flagIcon"></span>
                      <span class="ms-2">{{ country.label }}</span>
                    </div>
                  </ng-template>
                </p-autocomplete>
                <label for="pickupLocationUid">Country</label>
              </p-iftalabel>
            </div>
            <div class="col-sm-6">
              <div class="form-floating">
                <input type="text" class="form-control validated" id="city" formControlName="city" />
                <label for="city">City</label>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-floating">
                <input type="text" class="form-control validated" id="zipCode" formControlName="zipCode" />
                <label for="zipCode">Zip Code</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="row align-items-center g-1">
            <div class="col-12">
              <div class="small fw-semibold">Driver's License</div>
            </div>
            <div class="col-12">
              <div class="form-floating">
                <input type="text" class="form-control validated" id="licenseNumber" formControlName="licenseNumber" />
                <label for="licenseNumber">License Number</label>
              </div>
            </div>
            <div class="col-sm-6">
              <p-iftalabel>
                <p-datepicker
                  formControlName="licenseExpirationDate"
                  inputId="licenseExpirationDate"
                  showIcon
                  iconDisplay="input"
                  appendTo="body" />
                <label for="licenseExpirationDate">Expiry Date</label>
              </p-iftalabel>
            </div>
            <div class="col-sm-6">
              <div class="form-floating">
                <input type="text" class="form-control validated" id="issuePlace" formControlName="licensePlace" />
                <label for="issuePlace">Issue Place</label>
              </div>
            </div>
            <div class="col-12">
              <div class="small fw-semibold mt-2">Document</div>
            </div>
            <div class="col-sm-6">
              <p-iftalabel>
                <p-select
                  [options]="[
                    { name: 'Other', code: 0, icon: 'fa-solid fa-id-badge fa-fw' },
                    { name: 'Identity Card', code: 1, icon: 'fa-solid fa-id-card fa-fw' },
                    { name: 'Passport', code: 2, icon: 'fa-solid fa-passport fa-fw' }
                  ]"
                  optionLabel="name"
                  optionValue="code"
                  formControlName="documentType"
                  [fluid]="true"
                  placeholder="Select a Document Type">
                  <ng-template let-documentType pTemplate="item">
                    <div>
                      <span><i [class]="documentType.icon" class="text-secondary"></i></span>
                      <span class="ms-2">{{ documentType.name }}</span>
                    </div>
                  </ng-template>
                </p-select>
                <label for="documentType">Document Type</label>
              </p-iftalabel>
            </div>
            <div class="col-sm-6">
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control validated"
                  id="documentNumber"
                  formControlName="documentNumber" />
                <label for="documentNumber">Document Number</label>
              </div>
            </div>
            <div class="col-sm-6">
              <p-iftalabel>
                <p-datepicker
                  formControlName="documentIssueDate"
                  inputId="documentIssueDate"
                  showIcon
                  iconDisplay="input"
                  appendTo="body" />
                <label for="documentIssueDate">Issue Date</label>
              </p-iftalabel>
            </div>
            <div class="col-sm-6">
              <div class="form-floating">
                <input
                  type="text"
                  class="form-control validated"
                  id="documentIssuePlace"
                  formControlName="documentIssuePlace" />
                <label for="documentIssuePlace">Issue Place</label>
              </div>
            </div>
            <div class="col-12">
              <div class="small fw-semibold mt-2">Other</div>
            </div>
            <div class="col-sm-12">
              <div class="form-floating">
                <input type="text" class="form-control validated" id="flightNumber" formControlName="flightNumber" />
                <label for="flightNumber">Flight Number</label>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="bg-100 rounded p-2">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="isAdditionalDriver"
                    formControlName="isAdditionalDriver" />
                  <label class="form-check-label fs-7" for="isAdditionalDriver">Additional Driver</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (errors) {
        <div class="row align-items-center g-1 pt-1 m-1">
          <div class="col-12">
            <div class="alert alert-danger m-0">
              @for (error of errors; track $index) {
                <div class="text-center">{{ error }}</div>
              }
            </div>
          </div>
        </div>
      }
    </form>
  </div>
  <div class="modal-footer">
    @if (!isReadonly()) {
      <button
        type="submit"
        form="3da94a1a-7a43-4ccd-bf88-498c6f861bfc"
        class="btn btn-success"
        [disabled]="!form.valid || !form.dirty">
        <div class="d-flex justify-content-center align-items-center gap-2">
          <div>
            <i class="fa-solid fa-save fa-fw"></i>
          </div>
          <div>Confirm</div>
        </div>
      </button>
    }
    <button type="button" class="btn btn-outline-secondary" (click)="dismiss()">Close</button>
  </div>
} @else {
  <div class="modal-body">
    <app-loader />
  </div>
}
